import React from 'react';

import createSvgIcon from '../Utils/CreateSvgIcon';

export const DoubleChevronLeft = createSvgIcon(
  <React.Fragment>
    <path
      clipRule="evenodd"
      d="M6.41427 12.0711L12.7782 5.70718L11.364 4.29297L3.58584 12.0711L11.364 19.8493L12.7782 18.4351L6.41427 12.0711Z"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.4143 12.0711L18.7782 5.70718L17.364 4.29297L9.58584 12.0711L17.364 19.8493L18.7782 18.4351L12.4143 12.0711Z"
      fillRule="evenodd"
    />
  </React.Fragment>,
  'DoubleChevronLeft',
);
